// extracted by mini-css-extract-plugin
export var sliderRange = "_ch-2";
export var sliderRoot = "_ch-0";
export var sliderThumb = "_ch-3";
export var sliderTrack = "_ch-1";